import {ModalBody} from "@/components/modal/index";
import {observer} from "mobx-react";
import axios from "axios";
import {useStore} from "@/store";
import React, {useEffect, useRef, useState} from "react";
import Input from "@/components/common/Input";
import {setDraw} from "@/app/search/controller";
import styled from "styled-components";
import {CiCircleMinus, CiCirclePlus} from "react-icons/ci";
import Button from "@/components/common/Button";
import {setToast} from "@/utils";
import {ButtonWrap} from "@/styles/CommonStyle";

const CooperationBrandOrderAddModal = observer(({handleCloseModal, modalDepth, confirmFunc}) => {
    const {boardDetailStore} = useStore();
    const brandInputRefs = useRef([]);
    useEffect(() => {
        boardDetailStore.getCooperationBrandOrder().then();
    }, []);


    const validateCooperationOrder = () => {
        const list = boardDetailStore.cooperationBradOrderList.map(row => ({brand: (row.brand).trim(), endDate: (row.endDate).trim()}));
        for (let i = 0; i < list.length; i++) {
            const row = list[i];
            const rowNum = i + 1;
            if (!row.brand) {
                return {
                    confirm: false,
                    message: `${rowNum}번째 브랜드쪽 내용이 비어있습니다.`,
                };
            }
            if (!row.endDate) {
                return {
                    confirm: false,
                    message: `${rowNum}번째 마감일정쪽 내용이 비어있습니다.`,
                };
            }
        }
        return {
            confirm: true,
            list,
        };
    }

    return(
        <OrderWrapper>
            <OrderWrap>
                <div className={"wrap"}>
                    <div className={"order-title"}>
                        <div className={"inner"}>브랜드(Maker)</div>
                        <div className={"inner"}>발주 마감일정</div>
                    </div>
                    {boardDetailStore.cooperationBradOrderList.map((row, idx) => (
                        <OrderInner key={idx} className={"order-inner"}>
                            <div className={"list-inner"}>
                                <Input
                                    inputType="text"
                                    placeholder="브랜드를 입력해주세요"
                                    width={"fill"}
                                    value={row.brand}
                                    ref={(el) => (brandInputRefs.current[idx] = el)}
                                    onChange={(e) =>
                                        boardDetailStore.updateOrderRow(idx, "brand", e.target.value)
                                    }
                                />
                                <Input
                                    inputType="text"
                                    placeholder="발주 마감일정 값을 입력해주세요"
                                    width={"fill"}
                                    value={row.endDate}
                                    onChange={(e) =>
                                        boardDetailStore.updateOrderRow(idx, "endDate", e.target.value)
                                    }
                                />
                                <div className={"control-btn-wrap"}>
                                    <div
                                        className={"control-btn"}
                                        onClick={() => {
                                            const newIdx = boardDetailStore.addOrderRow();
                                            requestAnimationFrame(() => {
                                                brandInputRefs.current[newIdx]?.focus?.();
                                            });
                                        }}
                                    >
                                        <CiCirclePlus size={20} color={"#333"}/>
                                    </div>
                                    <div
                                        className={"control-btn"}
                                        onClick={() =>
                                            boardDetailStore.removeOrderRow(idx)
                                        }
                                    >
                                        <CiCircleMinus size={20} color={"#333"}/>
                                    </div>
                                </div>
                            </div>
                        </OrderInner>
                    ))}
                </div>
                <ButtonWrap className={"center cooperation-btn-wrap"} $gap={10}>
                    <Button
                        type="solid"
                        size="m"
                        round={true}
                        text={"취소"}
                        onClickFunc={async () => {
                            handleCloseModal(modalDepth);
                        }}
                    />
                    <Button
                        type="fill"
                        size="m"
                        round={true}
                        text={"등록"}
                        onClickFunc={async () => {
                            const result = validateCooperationOrder();
                            if (!result.confirm) {
                                setToast("warning", result.message);
                                return;
                            }
                            try {
                                const response = await boardDetailStore.setSaveCooperationBrandOrder(result.list);
                                if (response) {
                                    await boardDetailStore.getCooperationBrandOrder();
                                    setToast("success", "등록 되었습니다.")
                                    // confirmFunc();
                                }
                            } catch (e) {

                            }
                        }}
                    />
                </ButtonWrap>
            </OrderWrap>
        </OrderWrapper>
    )
});
const OrderWrapper = styled.div`
    height: 100%;
    overflow: hidden;
`
const OrderWrap = styled.div`
    margin-top: 80px;
    height: calc(100% - 80px);
    padding: 0 15px;
    overflow: auto;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 24px;
    .order-title{
        display: flex;
        align-items: center;
        margin-bottom: 10px;
        .inner{
            width: calc(50% - 10px);
        }
    }
    .order-inner{
        & + .order-inner{
            margin-top: 10px;
            padding-top: 10px;
            border-top: 1px solid #ccc;
        }
    }
`
const OrderInner = styled.div`
    .list-inner{
        display: flex;
        align-items: center;
        .input-wrapper{
            & + .input-wrapper{
                margin-left: 20px;
            }
        }
    }
    .control-btn-wrap{
        display: flex;
        align-items: center;
        margin-left: 10px;
        gap: 5px;
        .control-btn{
            cursor: pointer;
        }
    }
`

export default CooperationBrandOrderAddModal